/**
 * Created by Hardy on 2018/1/23.
 */
import api from '../fetch/api'
import * as types from './types'
import axios from 'axios'
import router from "../router/index"
export default {
  storeToken({state},payload){
    return new Promise((resolve)=>{
      for (let key in payload){
        window.sessionStorage.setItem(key,payload[key]);
        state[key] = payload[key];
      }
      axios.defaults.headers.common['Authorization'] = window.btoa(unescape(encodeURIComponent(state.token)));
      resolve();
    })
  },
  updateDocInfo ({dispatch,commit},payload){
    commit('IS_UPDATE_DOCINFO',false);
    return new Promise((resolve)=>{
          api.initInfo()
            .then(obj=>{
              let obj1 ={
                account: '',
                name : '',
                sex : '男',
                department : '',
                technical : '',
                skill : '',
                abstract : '',
                hope : '',
                hospital : '',
                hospitals_code : '',
                provinces_area_id : '',
                area_id : ' '
              }
              //未注册情况
              if(obj.code == '10006'){
                obj1.isRegister = '2';
                Object.assign(obj,{info : obj1});
              }else{
                // context.commit(types.UPDATE_MESSAGE_LIST,obj.messages);
                commit('IS_UPDATE_DOCINFO',false);
              }
              if(obj.info.isRegister == '2'){
                Object.assign(obj.info,obj1);
              }
              commit(types.UPDATE_DOCSELFINFO,obj.info);
              //未完善信息的情况
              // resolve(obj);
              if(obj.info.isRegister == '2'){
                router.push('/addInfo');
                return;
              }
              if(obj.info.is_certified != '1' ){
                  router.push(`/${obj.info.is_certified}/successTip`);
                  return;
              }else{
                  //为true说明第一次进入应用 需要进行聊天系统的登录
                  if(payload){
                    dispatch('connConfig');
                  }
                  resolve();
              }
            }).catch(()=>{
              commit('UPDATE_LOADING',true);
          })
    })
  },
  updatePatinfo({commit,state},payload){
    return new Promise((resolve)=>{
      if(payload){
        api.patInfo(payload)
          .then(obj=>{
            //更新用户信息
            obj.info.order = obj.order;
            commit('UPDATE_PATSELFINFO',obj.info);
            resolve(obj);
          })
      }else{
        resolve();
      }
    })
  },
  unReplayCount({state}){
    let v = {
      state : false,
      arr : []
    }
    api.undo().then((obj)=>{
      for (let key  in obj){
        v.arr[key]= Number(obj[key]);
      }
      state.unReplay = Object.assign({},v);
    })
  },
  gainPatients({state}){
    let allPatients =   {
      all : [],
      device_group : {id : '',name :'',patients : []},
      vip_group:[{id : '',name :'',patients : []},{id : '',name :'',patients : []}],
      other_group : [{id : '',name :'',patients : []}]
    };
    let all_patients=[];
    return new Promise((resolve)=>{
      api.gainAllPat().then(obj=>{
        obj.all.forEach((v)=>{
          switch (v.group_id){
            case '':
              switch (v.group_name){
                case "device_patients":
                  v.name  = '肺功能管理组';
                  v.active = false;
                  allPatients.device_group = v;
                  break;
                case "family_service":
                  v.active = false;
                  v.name  = '图文咨询(按期)';
                  allPatients.vip_group[0] = v;
                  break;
                case "inquiry_service":
                  v.active = false;
                  v.name  = '图文咨询(按次)';
                  allPatients.vip_group[1] = v;
                  break;
                case "no_service":
                  v.name  = '普通会员';
                  v.active = false;
                  allPatients.other_group.unshift(v);
                  break;
                case "no_group":
                  v.name  = '未分组';
                  v.active = false;
                  allPatients.other_group.push(v);
                  allPatients.all = allPatients.all.concat(v.patients);
                  break;
              }
              break;
            default :
              switch (v.group_name){

                default :
                  v.name  = v.group_name;
                  v.active = false;
                  allPatients.all = allPatients.all.concat(v.patients);
                  allPatients.other_group.push(v);
                  break;
              }
          }
        })
        obj.all.forEach((e)=>{
          switch (e.group_id){
            case '':
              switch (e.group_name){
                case "device_patients":
                  e.active = false;
                  all_patients[0] = e;
                  break;
                case "family_service":
                  e.active = false;
                  e.name  = '图文咨询(按期)';
                  all_patients[1] = e;
                  break;
                case "inquiry_service":
                  e.active = false;
                  e.name  = '图文咨询(按次)';
                  all_patients[2] = e;
                  break;
                case "no_service":
                  e.name  = '普通会员';
                  e.active = false;
                  all_patients[3] = e;
                  break;
                case "no_group":
                  e.name  = '未分组';
                  e.active = false;
                  all_patients[4] = e;
                  break;
              }
              break;
            default :
              switch (e.group_name){

                default :
                  e.name  = e.group_name;
                  e.active = false;
                  // allPatients.all = allPatients.all.concat(v.patients);
                  all_patients.push(e);
                  break;
              }
          }
        })
        state.allPatients = Object.assign({},allPatients);
        state.all_patients =Object.assign([],all_patients);
        // console.log(state.all_patients)
        resolve();
      })
    })
  },
  // 研究编号储蓄
  setResearchNumber({ state, commit }, number) {
    window.sessionStorage.setItem('MY_RESEARCH_NUMBER', number);
    commit('MY_RESEARCH_NUMBER', number);
  }
}



// WEBPACK FOOTER //
// ./src/vuex/rootActions.js